import { isEqual } from 'lodash-es';

export function toFormValues(model: any, originalModel: any): any {
  const requestData: any = {};
  Object.keys(model).forEach((key: string) => {
    if (!(key in originalModel)) {
      requestData[key] = {
        changed: true,
        value: model[key],
      };
    } else {
      const changed = !isEqual(model[key], originalModel[key]);
      requestData[key] = {
        changed,
        value: model[key],
      };
    }
  });

  return requestData;
}
